import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReviewApi from '../../apis/review.api';
import AppAlert from '../../components/AppAlert';
import { PencilSvg, PlusBlueSvg, TrashSvg } from '../../components/Assets';
import DashedOutlineBtn from '../../components/buttons/DashedOutlineBtn';
import PopupArea from '../../components/modal/PopupArea';
import Spinner from '../../components/spinner/Spinner';
import { ROUTE_PATHS } from '../../constants/Router';
import { ADDITIONAL_COMMENT_SETTINGS } from '../../text-data';

export default function ReviewSettingAdditionalComment({ additionList, setAdditionList }) {
  const navigate = useNavigate();
  const [openDelete, setOpenDelete] = useState(false);
  const [additionalCommentIdx, setAdditionalCommentIdx] = useState(null);
  const [loading, setLoading] = useState(false);

  const onAddNew = () => {
    navigate(ROUTE_PATHS.ReviewAdditionalComment, {
      state: {
        reviewSettingItem: null,
        additionList,
      },
    });
  };

  const [popupContent, setPopupContent] = useState(null);
  const closeModal = () => setPopupContent(null);

  const handleDelete = async () => {
    try {
      setOpenDelete(false);
      setLoading(true);
      await ReviewApi.deleteAddition(additionalCommentIdx);
      const filteredList = additionList.filter((x) => x.additional_comment_idx !== additionalCommentIdx);
      setAdditionList(filteredList);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='bg-white pt-6 pb-32 px-5 flex-col gap-6'>
      <div className='flex flex-col mb-6'>
        <div className='flex justify-between mb-4'>
          <div className='font-bold text-lg text-darkblue'>{ADDITIONAL_COMMENT_SETTINGS}</div>
        </div>
        <p>추천 댓글에 덧붙일 매장, 이벤트 홍보 등 문구를 설정해 보세요. 최대 3개 까지만 설정 가능해요.</p>
      </div>
      {additionList.map((item, index) => {
        return (
          <div key={index} className='flex justify-between py-6 px-5 gap-4 items-center'>
            <div className='flex items-center gap-6 flex-1'>
              <b>{index + 1}</b>
              <div className='flex flex-col gap-2'>
                <b className='text-appblue text-xs'>{item?.addtionalCommentStores?.filter((x) => x.applied)?.length}개 매장에 적용 중</b>

                <b className='text-base'>{item.title}</b>
              </div>
            </div>
            <div className='flex gap-3 '>
              <img
                className='w-6 h-6'
                onClick={() =>
                  navigate(ROUTE_PATHS.ReviewAdditionalComment, {
                    state: {
                      reviewSettingItem: item,
                      additionList,
                    },
                  })
                }
                src={PencilSvg}
              />

              <span className='w-6 h-6 flex items-center justify-center'>
                {loading && additionalCommentIdx === item.additional_comment_idx ? (
                  <Spinner isLoading={loading} color='#000' />
                ) : (
                  <img
                    onClick={() => {
                      setOpenDelete(true);
                      setAdditionalCommentIdx(item.additional_comment_idx);
                    }}
                    src={TrashSvg}
                  />
                )}
              </span>
            </div>
          </div>
        );
      })}
      <DashedOutlineBtn className={'py-7 w-full flex justify-center'} onClick={onAddNew}>
        <img className='w-3 h-3' src={PlusBlueSvg} />
      </DashedOutlineBtn>

      <ul className='list-disc pl-6 mt-6'>
        <li>현재 해당 기능은 배달의 민족과 요기요에서만 설정 가능하며, 쿠팡이츠는 글자 수의 제한으로 추가 댓글을 제공하지 않아요.</li>
        <li>관심리뷰는 추가 댓글이 적용되지 않아요.</li>
        <li>추가 댓글은 최대 700자까지 작성할 수 있어요.</li>
      </ul>

      <PopupArea popupContent={popupContent} closeModal={closeModal} />

      <AppAlert
        title='추천 댓글이 삭제되고 <br/>
        아무런 댓글도 등록되지 않아요.'
        desc='댓글 등록 제외 시 해당 댓글은 더 이상 <br />
        스폰지에서 관리 하실 수 없어요.'
        open={openDelete}
        onOk={handleDelete}
        onClose={() => setOpenDelete(false)}
        okText='등록 제외'
        cancelText='취소'
        type='error'
        okButtonRed={true}
      />
    </div>
  );
}
